export const VIEW_PATHS_ACCESS_OM_DEMO = {
  LOGIN: '/login',
  LOGOUT: '/logout',
} as const;
